module.exports = __webpack_public_path__ + "static/media/Reg-Dep-startionary.846869ac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/regionalna-deponija/Reg-Dep-startionary.jpg
// module id = 437
// module chunks = 0